<div class="container py-3">
  <h2 class="mb-3">Change Your NTRIP Connection Credential</h2>

    <div *ngIf="selectedUser">
      <form (ngSubmit)="onSubmit()">
        <div class="subsection">
          <div class="d-flex justify-content-between align-items-center mb-2 subheader">
            <h4 class="m-0 subsection-title">NTRIP Credentials</h4>
          </div>

          <div class="mb-2" style="max-width: 720px;">
            <label class="form-label">NTRIP UserName (RTK Bases):</label>
            <span class="material-icons ms-1" style="font-size:18px; cursor:pointer; vertical-align: middle;"
                  matTooltip="This username must be unique across our entire system. If the update failed, please enter a different username."
                  (click)="openInfo('This username must be unique across our entire system. If the update failed, please enter a different username.')">info</span>
            <input type="text" class="form-control" [(ngModel)]="selectedUser.uUserName" name="uUserName">
          </div>

          <div class="mb-2" style="max-width: 720px;">
            <label class="form-label">NTRIP Password (RTK Bases):</label>
            <input type="text" class="form-control" [(ngModel)]="selectedUser.uPassword" name="uPassword">
          </div>

          <div class="mb-2" style="max-width: 720px;">
            <label class="form-label">NTRIP UserName (RTK Rovers):</label>
            <span class="material-icons ms-1" style="font-size:18px; cursor:pointer; vertical-align: middle;"
                  matTooltip="This username must be unique across our entire system. If the update failed, please enter a different username."
                  (click)="openInfo('This username must be unique across our entire system. If the update failed, please enter a different username.')">info</span>
            <input type="text" class="form-control" [(ngModel)]="selectedUser.dUserName" name="dUserName">
          </div>

          <div class="mb-3" style="max-width: 720px;">
            <label class="form-label">NTRIP Password (RTK Rovers):</label>
            <input type="text" class="form-control" [(ngModel)]="selectedUser.dPassword" name="dPassword">
          </div>

          <div class="text-end" style="max-width: 720px;">
            <button type="submit" class="btn btn-primary btn-sm">Update</button>
          </div>
        </div>
      </form>
    </div>
</div>


